import axios from "axios";

export const getBatchApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/batch/`, {
        params: params
    });
}

export const getBatchByIdApi = (idBatch, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/batch/${idBatch}`, {
        params: params
    });
}

export const aggiungiBatchApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/batch/`, payload, {
        params: params
    });
}

export const aggiornaBatchApi = (idBatch, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/batch/${idBatch}`, payload, {
        params: params
    });
}

export const deleteBatchApi = (idBatch, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/batch/${idBatch}`, {
        params: params
    });
}

export const getSchedulazioniApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/schedulazioni/`, {
        params: params
    });
}

export const getSchedulazioneByIdApi = (idSchedulazione, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/schedulazioni/${idSchedulazione}`, {
        params: params
    });
}

export const aggiungiSchedulazioneApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/schedulazioni/`, payload, {
        params: params
    });
}

export const aggiornaSchedulazioneApi = (idSchedulazione, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/schedulazioni/${idSchedulazione}`, payload, {
        params: params
    });
}

export const deleteSchedulazioneApi = (idSchedulazione, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/scheduler/schedulazioni/${idSchedulazione}`, {
        params: params
    });
}